module.exports = __webpack_public_path__ + "src/img/artist/work09_3.jpg?b8a756b8042c92a609a5fac282f76e14";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work09_3.jpg
// module id = 165
// module chunks = 0